import SamplePlaceholder from 'components/GlobalModals/ProductSamplesModal/Minidrawer/SamplePlaceholder/SamplePlaceholder';

export default SamplePlaceholder;
